import { GenericHeader } from "../../utility/common/TransactionComponents/Generic_WPQ_WPS_PQR_header";
  
export const PQRHeader = ({ headerObj, WPStype }) => {
  const isTubesheet = WPStype === "Tubesheet";

  const headerData = [
    { label: "PQR Record No", value: headerObj?.PQR_RecordNo },
    { label: "Date", value: isTubesheet ? headerObj?.PQR_Date : headerObj?.PQR_DOB },
    { 
      label: isTubesheet ? "Qualification Code" : "", 
      value: isTubesheet ? headerObj?.PQR_Qualificationcode : headerObj?.PQR_ReviNo 
    },
    { 
      label: isTubesheet ? "WPS No" : "WPS Record Number", 
      value: isTubesheet ? headerObj?.PQR_pWPSNo : headerObj?.PQR_WPS_RecordNo 
    },
    { label: "WPS Revision No", value: headerObj?.PQR_WPS_ReviNo },
    ...(isTubesheet ? [] : [{ label: "Company Name", value: headerObj?.PQR_CompanyName }])
  ];
  console.log("headerObj",headerObj);

  return <GenericHeader headerData={headerData} />;
};


// export const PQRHeader = ({ headerObj, WPStype }) => {
//   const isTubesheet = WPStype === "Tubesheet";
//   const isOverlay = headerObj?.wld_WPSType === "Overlay"; 

//   const headerData = [
//     { label: "PQR Record No", value: headerObj?.PQR_RecordNo },
//     { label: "Date", value: isTubesheet ? headerObj?.PQR_Date : headerObj?.PQR_DOB },

    
//     ...(!isOverlay
//       ? [{
//           label: isTubesheet ? "Qualification Code" : "Revision",
//           value: isTubesheet
//             ? headerObj?.PQR_Qualificationcode
//             : headerObj?.PQR_ReviNo
//         }]
//       : []),

//     {
//       label: isTubesheet ? "WPS No" : "WPS Record Number",
//       value: isTubesheet
//         ? headerObj?.PQR_pWPSNo
//         : headerObj?.PQR_WPS_RecordNo
//     },

//     { label: "WPS Revision No", value: headerObj?.PQR_WPS_ReviNo },

//     ...(isTubesheet
//       ? []
//       : [{ label: "Company Name", value: headerObj?.PQR_CompanyName }])
//   ];

//   console.log("headerObj", headerObj);

//   return <GenericHeader headerData={headerData} />;
// }